import React, { useEffect, useState } from 'react';
import { Card } from '../../components/ui/Card';
import { Table, Tr, Td } from '../../components/ui/Table';
import { Badge } from '../../components/ui/Badge';
import { Notice } from '../../components/ui/Notice';
import { getBookings, confirmBooking } from '../../api/bookings';
import { Booking } from '../../types';
import { formatCurrency, formatDate } from '../../utils/format';

export const BookingsAdmin: React.FC = () => {
  const [bookings, setBookings] = useState<Booking[]>([]);
  const [selected, setSelected] = useState<Booking | null>(null);

  const load = () => getBookings().then(r => setBookings(r.data.results || r.data));
  useEffect(() => { load(); }, []);

  const handleConfirm = async (id: string) => {
    await confirmBooking(id);
    load();
  };

  return (
    <div>
      <h1 style={{ fontSize: 20, fontWeight: 500, marginBottom: 20 }}>Semua Booking</h1>
      <div style={{ display: 'grid', gridTemplateColumns: selected ? '1fr 380px' : '1fr', gap: 16 }}>
        <Card title="Daftar booking">
          <Table headers={['Kode', 'Hotel', 'Kamar', 'Tamu', 'Checkin', 'Total', 'Status', 'Aksi']}>
            {bookings.map(b => (
              <Tr key={b.id}>
                <Td><span style={{ fontFamily: 'monospace', fontSize: 11, cursor: 'pointer', color: '#185FA5' }} onClick={() => setSelected(b)}>{b.booking_code}</span></Td>
                <Td style={{ fontSize: 12 }}>{b.hotel_name}</Td>
                <Td style={{ fontSize: 12 }}>{b.room_type}</Td>
                <Td style={{ fontSize: 12 }}>{b.guest_name}</Td>
                <Td style={{ fontSize: 12 }}>{formatDate(b.checkin_date)}</Td>
                <Td style={{ fontWeight: 500 }}>{formatCurrency(b.total_price)}</Td>
                <Td><Badge status={b.status} /></Td>
                <Td>
                  {b.status === 'pending' && (
                    <button onClick={() => handleConfirm(b.id)}
                      style={{ padding: '4px 10px', background: '#0F6E56', color: '#fff', border: 'none', borderRadius: 6, fontSize: 11, cursor: 'pointer' }}>
                      Konfirmasi
                    </button>
                  )}
                </Td>
              </Tr>
            ))}
          </Table>
        </Card>
        {selected && (
          <Card title={`Detail — ${selected.booking_code}`}>
            <button onClick={() => setSelected(null)} style={{ marginBottom: 12, border: '0.5px solid rgba(0,0,0,0.15)', background: 'transparent', padding: '4px 10px', borderRadius: 6, fontSize: 12, cursor: 'pointer' }}>Tutup</button>
            <div style={{ fontSize: 13 }}>
              <div style={{ marginBottom: 8 }}><strong>Tamu:</strong> {selected.guest_name}</div>
              <div style={{ marginBottom: 8 }}><strong>Hotel:</strong> {selected.hotel_name}</div>
              <div style={{ marginBottom: 8 }}><strong>Kamar:</strong> {selected.room_type} ({selected.nights} malam)</div>
              <div style={{ marginBottom: 8 }}><strong>Checkin:</strong> {formatDate(selected.checkin_date)}</div>
              <div style={{ marginBottom: 16 }}><strong>Agen:</strong> {selected.agent_name}</div>
            </div>
            {selected.snapshot && (
              <>
                <div style={{ fontSize: 11, fontWeight: 500, color: '#888780', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 8 }}>Price Snapshot</div>
                <Notice type="info">Data ini hanya terlihat oleh Superadmin. Agen tidak melihat base rate.</Notice>
                <div style={{ background: '#f8f8f7', borderRadius: 8, padding: 12, fontSize: 12 }}>
                  {selected.snapshot.base_rate && <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', color: '#888780' }}><span>Base rate</span><span>{formatCurrency(selected.snapshot.base_rate)}</span></div>}
                  {selected.snapshot.hotel_incentive_amount && <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', color: '#888780' }}><span>Hotel incentive</span><span style={{ color: '#854F0B' }}>−{formatCurrency(selected.snapshot.hotel_incentive_amount)}</span></div>}
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', color: '#888780' }}><span>Admin markup ({selected.snapshot.admin_markup_pct}%)</span><span>{formatCurrency(selected.snapshot.admin_markup_amount)}</span></div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', color: '#888780' }}><span>Sub markup ({selected.snapshot.sub_markup_pct}%)</span><span>{formatCurrency(selected.snapshot.sub_markup_amount)}</span></div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0 0', marginTop: 4, borderTop: '0.5px solid rgba(0,0,0,0.1)', fontWeight: 500, fontSize: 14 }}><span>Total</span><span>{formatCurrency(selected.snapshot.final_price)}</span></div>
                </div>
              </>
            )}
          </Card>
        )}
      </div>
    </div>
  );
};
